import { FormattedMessage } from 'react-intl';

interface ShareButtonProps {
	url: string;
	title: string;
	text: string;
}

const ShareButton = ({ url, title, text }: ShareButtonProps) => {
	const handleShare = () => {
		return navigator.share({
			title,
			text,
			url
		});
	};

	return (
		<button className="button-share filled" onClick={handleShare}>
			<span className="icon icon-arrow-curve" />
			<span>
				<FormattedMessage id="share-modal.button.share" />
			</span>
		</button>
	);
};

export default ShareButton;
